import { ConnectionsActionsHeapEvents } from './connections/events'
import { ListingsHeapEvents } from './listings/listingsTrackingEvents'
import { BusinessDetailsHeapEvents } from './locationDetails/businessDetails/businessDetailsTrackingEvents'
import { CoreInfoHeapEvents } from './locationDetails/coreInfo/coreInfoTrackingEvents'
import { HoursHeapEvents } from './locationDetails/hours/hoursTrackingEvents'
import { LinkedLocationProfilesHeapEvents } from './locationDetails/linkedLocationProfiles/linkedLocationProfilesTrackingEvents'
import { PhotoGalleryHeapEvents } from './locationDetails/photoGallery/photoGalleryTrackingEvents'
import { WebsitesSocialMediaHeapEvents } from './locationDetails/websiteSocialMedia/websitesSocialMedia'

export enum LabelsHeapEvents {
  saveLabel = 'save-label',
  deleteLabel = 'delete-label',
  addLabelToReview = 'add-label-to-review',
  removeLabelFromReview = 'remove-label-from-review',
}

export enum TemplatesHeapEvents {
  saveTemplate = 'save-template',
  deleteTemplate = 'delete-template',
}

export enum ReviewsHeapEvents {
  openDrawer = 'reviews-drawer-open-drawer',
  seeOriginal = 'reviews-drawer-see-original',
  saveDraft = 'reviews-drawer-save-draft',
  saveReply = 'reviews-drawer-save-reply',
  suggestButtonClick = 'reviews-drawer-suggest-button-click',
  copyToClipboard = 'reviews-drawer-copy-to-clipboard',
  savePrompt = 'reviews-prompt-save',
  deletePrompt = 'reviews-prompt-delete',
  textSearch = 'reviews-text-search',
}

export enum ReviewsInsightsDrawerHeapEvents {
  openDrawer = 'reviews-insights-drawer-open-drawer',
  mainFiltersChanges = 'reviews-insights-drawer-main-filters-changes',
  listFiltersChanges = 'reviews-insights-drawer-list-filters-changes',
}

export enum ReviewNotificationsHeapEvents {
  saveNewNotification = 'save-new-review-notification',
  saveEditedNotification = 'save-edited-review-notification',
  editButtonClick = 'edit-review-notification-button-click',
  deleteButtonClick = 'delete-review-notification-button-click',
}

export enum FirstPartyReviewsHeapEvents {
  createButtonClick = 'create-first-party-review--button-click',
  editButtonClick = 'edit-first-party-review-button-click',
  deleteButtonClick = 'delete-first-party-review-button-click',
  shareButtonClick = 'share-first-party-review-button-click',
}

export enum MarketIntelligenceHeapEvents {
  competitorWithoutAddressLine = 'market-intelligence--competitor-without-address-line',
  replaceCompetitor = 'market-intelligence--replace-competitor',
}

export enum MenusActionsHeapEvents {
  exportMenus = 'menus-actions-export',
  importMenus = 'menus-actions-import',
  importMenusValidation = 'menus-actions-import-validation',
}

export enum ItemsHeapEvents {
  createItemAttributes = 'create-item-attributes',
  updateItemAttributes = 'update-item-attributes',
}

export enum BulkDeleteActionsHeapEvents {
  bulkDeleteMenus = 'bulk-delete-menus',
  bulkDeleteSections = 'bulk-delete-sections',
  bulkDeleteItems = 'bulk-delete-items',
  bulkDeleteModifiers = 'bulk-delete-modifiers',
  bulkDeleteChoices = 'bulk-delete-choices',
}

export enum EmailReportsActionsHeapEvents {
  save = 'email-reports-save',
  delete = 'email-reports-delete',
  exportAnalyticsClick = 'email-reports-export-analytics-click',
  exportAnalyticsAction = 'email-reports-export-analytics-action',
  exportReviewAnalysisClick = 'email-reports-export-review-analysis-click',
  exportReviewAnalysisAction = 'email-reports-export-review-analysis-action',
}

export enum UsersActionsHeapEvents {
  save = 'user-save',
  confirmationEmailResend = 'user-confirmation-email-resend',
  disable = 'user-disable',
}

export enum RolesActionsHeapEvents {
  save = 'roles-save',
  delete = 'roles-delete',
}

export enum SocialManagementHeapEvents {
  saveDraft = 'save-draft',
  publishPost = 'publish-post',
  schedulePost = 'schedule-post',
  rePublishPost = 're-publish-post',
  deleteApplePosts = 'delete-apple-posts',
}

export enum WidgetsActionsHeapEvents {
  save = 'save-widget',
  delete = 'delete-widget',
  copyEmbedCode = 'copy-embed-code',
  createWidgetButtonClick = 'create-widget-button-click',
  selectWidgetType = 'select-widget-type',
}

export enum QuickNavigationHeapEvents {
  opened = 'quick-navigation-opened',
  itemClicked = 'quick-navigation-item-clicked',
  sidebarItemClicked = 'sidebar-item-clicked',
  fromLocationPageToLocationDetails = 'from-location-page-to-location-details',
}

const ALL_HEAP_EVENTS = [
  ...Object.values(LabelsHeapEvents),
  ...Object.values(TemplatesHeapEvents),
  ...Object.values(ListingsHeapEvents),
  ...Object.values(CoreInfoHeapEvents),
  ...Object.values(HoursHeapEvents),
  ...Object.values(BusinessDetailsHeapEvents),
  ...Object.values(WebsitesSocialMediaHeapEvents),
  ...Object.values(PhotoGalleryHeapEvents),
  ...Object.values(LinkedLocationProfilesHeapEvents),
  ...Object.values(ReviewsHeapEvents),
  ...Object.values(ReviewsInsightsDrawerHeapEvents),
  ...Object.values(ReviewNotificationsHeapEvents),
  ...Object.values(FirstPartyReviewsHeapEvents),
  ...Object.values(MenusActionsHeapEvents),
  ...Object.values(ItemsHeapEvents),
  ...Object.values(BulkDeleteActionsHeapEvents),
  ...Object.values(EmailReportsActionsHeapEvents),
  ...Object.values(UsersActionsHeapEvents),
  ...Object.values(RolesActionsHeapEvents),
  ...Object.values(ConnectionsActionsHeapEvents),
  ...Object.values(SocialManagementHeapEvents),
  ...Object.values(WidgetsActionsHeapEvents),
  ...Object.values(QuickNavigationHeapEvents),
  ...Object.values(MarketIntelligenceHeapEvents),
] as const
export type HeapEventsType = (typeof ALL_HEAP_EVENTS)[number]
